import { AoiShape } from "../../models/aois/AoiShape"
import { Project } from "../../models/projects/Project"
import { ProjectDetails } from "../../models/projects/ProjectDetails"
import { flattenObj } from "../../tools"
import { ValidatorModel } from "../../validation"

export const projectDisplayNames = {
    description: "Project Description",
    name: "AOI Name",
    source_file: "Source File",
    aoi_type: "AOI Type",
    notes: "AOI Notes",
    mode_ids: "Acq Mode",
}

type ProjectValidationType = ProjectDetails & AoiShape

export const getProjectValidatorModel = (project?: Project, aoi?: AoiShape): ValidatorModel => {
    const model = flattenObj({ ...project, aoi })

    const conditional_aoi_fields: (keyof AoiShape)[] = aoi != null ? ["name", "source_file", "aoi_type", "notes"] : []
    const conditional_mode_fields: (keyof AoiShape)[] = aoi != null && !model.mode_ids.length ? ["mode_ids"] : []

    const requiredFields: (keyof ProjectValidationType)[] = [
        "description",
        ...conditional_aoi_fields,
        ...conditional_mode_fields,
    ]

    return {
        model: model,
        display_names: projectDisplayNames,
        required_fields: requiredFields,
        unique_fields: [],
        custom_validation_fields: [],
        groups: {
            projectTab: ["description"],
            aoiTab: ["name", "source_file", "aoi_type", "notes", ...conditional_mode_fields],
        },
    }
}
